<template>
  <div class="MissionContainer">
    <img v-if="headerUrl"
         :src="headerUrl"
         class="img-header">
    <div class="pt-3 px-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      headerUrl: {
        required: false,
        type: String
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .MissionContainer {
    .img-header {
      max-height: 500px;
      width: 100%;
      display: flex;
      object-fit: cover;
    }
  }
</style>
